const form_404 = document.querySelector('.form_404');
const searchError_404 = document.querySelector('[data-search-error-404]');
const searchInput_404 = form_404?.querySelector('input[type="search"]');
const defaultSearch_404 = document.querySelector('.default_view');
const searchResults_404 = document.querySelector('.search_results_404');
const clearBtn_404 = form_404?.querySelector('.close_svg');

if(form_404){
    searchInput_404.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    });


    form_404.addEventListener('submit', (e) => {
        e.preventDefault();
    });

    function truncate( str, n, useWordBoundary ){
        if (str !== undefined) {
            const subString = str.substr(0, n-1); // the original check
            console.log(subString);
            return (useWordBoundary 
            ? subString.substr(0, subString.lastIndexOf(" ")) 
            : subString) + "&hellip;";
        }
    };

    function search(e) {
        setTimeout(() => {
            const searchTerm = searchInput_404.value.trim();
            
            if (searchTerm.length > 0) {
                defaultSearch_404.style.display = 'none';
                searchResults_404.style.display = 'grid';
                clearBtn_404.style.display = 'block';
            } 
            
            if (searchTerm.length == 0) {
                defaultSearch_404.style.display = 'flex';
                searchResults_404.style.display = 'none';
                searchResults_404.innerHTML = '';
                clearBtn_404.style.display = 'none';
            }
            

            fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product&resources[options][fields]=title,body,variants.title`)
            .then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }
            return response.json();
            })
            .then((suggestions) => { 
                searchResults_404.innerHTML = '';
                const productSuggestions = suggestions.resources.results.products;
                if(productSuggestions.length === 0) {
                    searchError_404.style.display = 'block';
                    defaultSearch_404.style.display = 'flex';
                    searchResults_404.style.display = 'none';
                    searchError_404.classList.add('search-results-404_error--active');
                    searchError_404.innerHTML = `Your search for “${searchTerm}” didn’t return any results.`;
                } else {
                    searchError_404.style.display = 'none';
                    const p = document.createElement('p');
                    p.classList.add('search-result-404');
                    p.innerHTML = `${productSuggestions.length} results`;
                    searchResults_404.appendChild(p);

                    const grid = document.createElement('div');
                    grid.classList.add('collection_grid_404');
                    searchResults_404.appendChild(grid);
                    productSuggestions.forEach(product => {
                        console.log(product);
                        grid.innerHTML += `
                        <li class="product-grid__item">
                            <a href="${product.url}">
                                <div class="product__image-404">
                                    <img src="${product.image}" alt="${product.title}">
                                </div>
                                <div class="product__info-404">
                                    <div class="product__info-title-404">${product.title}</div>
                                    <div class="product__info-price-404">$${product.price}</div>
                                </div>
                            </a>
                        </li>
                        `;
                    });
                }


            })
            .catch((error) => {
                console.log(error);
            throw error;
            }); 
            }, 500);

    }


    searchInput_404.addEventListener('input', (e) => {
        search(e);
    });

    clearBtn_404.addEventListener('click', (e) => {
        e.preventDefault();
        searchInput_404.value = '';
        search(e);
    });
}